import { render } from "./DayWiseDeposit.vue?vue&type=template&id=bff837ca"
import script from "./DayWiseDeposit.vue?vue&type=script&lang=js"
export * from "./DayWiseDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__